import { RedoPrintJobSchema } from "@redotech/redo-model/fulfillments/print-job";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import { VALID_PAGE_SIZES } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const searchPrintJobs = {
  name: "searchPrintJobs" as const,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number().optional(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    paginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    jobs: z.array(RedoPrintJobSchema),
    paginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export type SearchPrintJobsInput = z.infer<typeof searchPrintJobs.input>;
